import React from 'react';
import { isWaitlist, projectIsLive } from 'domain/vnm';
import { StyledStatus } from './styled-status';

interface Props {
  isPendingProductStatus?: boolean;
  projectStartDate?: Date;
  subscriptionStatus?: string | null;
  firstStatementWithSolarSavings?: boolean;
  projectName?: string;
  percentSavings?: number;
  isSMB?: boolean;
}

export enum Statuses {
  Pending = 'pending',
  WaitlistLive = 'waitlistLive',
  WaitlistNotLive = 'waitlistNotLive',
  FirstSolarStatement = 'firstSolarStatement',
}

export const VnmStatus = ({
  firstStatementWithSolarSavings,
  isPendingProductStatus,
  subscriptionStatus,
  projectStartDate,
  projectName,
  percentSavings,
  isSMB,
}: Props) => {
  if (isPendingProductStatus) {
    return <StyledStatus isSMB={isSMB} status={Statuses.Pending} />;
  } else if (
    subscriptionStatus &&
    isWaitlist(subscriptionStatus) &&
    projectIsLive(projectStartDate)
  ) {
    return <StyledStatus isSMB={isSMB} status={Statuses.WaitlistLive} />;
  } else if (subscriptionStatus && isWaitlist(subscriptionStatus)) {
    return (
      <StyledStatus
        isSMB={isSMB}
        status={Statuses.WaitlistNotLive}
        projectStartDate={projectStartDate}
      />
    );
  } else if (firstStatementWithSolarSavings) {
    return (
      <StyledStatus
        isSMB={isSMB}
        status={Statuses.FirstSolarStatement}
        projectName={projectName}
        percentSavings={percentSavings}
      />
    );
  } else {
    return null;
  }
};
